import { computed, reactive } from 'vue';
import { ITelaOperacao } from '../models/ITelaOperacao';
import { IRetornoRequisicao } from '../models/IRetornoRequisicao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';

export interface IModalBase {
  apresentarRetornoRequisicao(retorno: IRetornoRequisicao): unknown;
  textoBotaoSalvar: string;
  textoBotaoSalvarNovo: string;
  apresentarBarraProgresso: boolean;
  fraseBarraProgresso: string;
  exibirRequisicaoModal: boolean;
  retornoRequisicao: IRetornoRequisicao;
  computedOperacao: ITelaOperacao;
  computedVisivel: boolean;
}
export interface IRetornoModalBase{
  modalBase: IModalBase;
  defineNovaOperacao: (telaOperacao:ITelaOperacao) => void;
  defineTextoPadraoBotoes:(permissaoDados: EPermissaoDados, expressaoNova?: boolean) => void;
  apresentarBarraProgresso: (frase?: string) => void;
  ocultarBarraProgresso: () => void;
  apresentarRetornoRequisicao: (retornoRequisicao: IRetornoRequisicao) => void;
  sincronizarRegistro: (permissaoDados: EPermissaoDados, codigoRegistro:number) => void;
}
export function useModalBase(props:any, emit: any):IRetornoModalBase {
  const modalBase = reactive({
    textoBotaoSalvar: 'Concluir cadastro',
    textoBotaoSalvarNovo: 'Concluir e novo',
    apresentarBarraProgresso: false,
    fraseBarraProgresso: '',
    exibirRequisicaoModal: false,
    retornoRequisicao: {} as IRetornoRequisicao,
    apresentarRetornoRequisicao: (retornoRequisicao: IRetornoRequisicao) => {
      modalBase.apresentarBarraProgresso = false;
      modalBase.fraseBarraProgresso = '';
      modalBase.exibirRequisicaoModal = true;
      modalBase.retornoRequisicao = retornoRequisicao;
    },
    computedOperacao: computed({
      get: () => props.telaGenerica,
      set: (val: ITelaOperacao) => {
        emit('update:operacao', val);
      },
    }),
    computedVisivel: computed({
      get: () => props.visivel,
      set: (val: boolean) => {
        emit('update:visivel', val);
      },
    }),
  });

  function defineNovaOperacao(telaOperacao:ITelaOperacao) {
    const novaOperacao: ITelaOperacao = telaOperacao;
    novaOperacao.codigoRegistro = 0;
    novaOperacao.tipoPermissaoDados = EPermissaoDados.Incluir;
    modalBase.computedOperacao = novaOperacao;
  }

  function defineTextoPadraoBotoes(permissaoDados: EPermissaoDados, expressaoNova?: boolean) {
    if (permissaoDados === EPermissaoDados.Incluir) {
      modalBase.textoBotaoSalvar = 'Concluir cadastro';
      modalBase.textoBotaoSalvarNovo = expressaoNova ? 'Concluir e nova' : 'Concluir e novo';
    } else if (permissaoDados === EPermissaoDados.Visualizar) {
      modalBase.textoBotaoSalvar = 'Salvar alterações';
      modalBase.textoBotaoSalvarNovo = expressaoNova ? 'Salvar e nova' : 'Salvar e novo';
    } else {
      modalBase.textoBotaoSalvar = '';
      modalBase.textoBotaoSalvarNovo = '';
    }
  }

  function sincronizarRegistro(permissaoDados: EPermissaoDados, codigoRegistro:number) {
    emit('sincronizarRegistro', permissaoDados, codigoRegistro);
  }

  function apresentarBarraProgresso(frase?: string) {
    modalBase.apresentarBarraProgresso = true;
    modalBase.exibirRequisicaoModal = true;
    modalBase.fraseBarraProgresso = frase === undefined ? '' : frase;
  }

  function ocultarBarraProgresso() {
    modalBase.exibirRequisicaoModal = false;
    modalBase.apresentarBarraProgresso = false;
    modalBase.fraseBarraProgresso = '';
  }
  function apresentarRetornoRequisicao(retornoRequisicao: IRetornoRequisicao) {
    modalBase.apresentarBarraProgresso = false;
    modalBase.fraseBarraProgresso = '';
    modalBase.exibirRequisicaoModal = true;
    modalBase.retornoRequisicao = retornoRequisicao;
  }

  // ensure the reactive object exposes the actual implementation required by IModalBase
  modalBase.apresentarRetornoRequisicao = apresentarRetornoRequisicao;

  return {
    modalBase,
    defineNovaOperacao,
    defineTextoPadraoBotoes,
    apresentarBarraProgresso,
    ocultarBarraProgresso,
    apresentarRetornoRequisicao,
    sincronizarRegistro,
  };
}
